import Cookies from 'js-cookie';
import { clearDeviceId } from '@/helpers/deviceId';

const userAuth = JSON.parse(localStorage.getItem('userAuth')); // Parsing ke objek

const state = userAuth ? {
    ...userAuth,
    token: sessionStorage.getItem('token') || null,
} : {
    authenticated: false,
    token: null,
    user: {},
    userHasRoles: [],
    userHasPermissions: [],
    menuNav: [],
    subMenuNav: [],
    selectedModule: null,
}

const mutations = {
    set(state, data) {
        state.authenticated = true;
        const token = data?.token || (typeof data === 'string' ? data : null);
        if (token) {
            state.token = token;
            // Simpan token di sessionStorage (scoped ke tab browser, BUKAN di localStorage)
            sessionStorage.setItem('token', token);
        }
        if (data?.user) {
            state.user = data.user;
        }

        // Hapus token dari localStorage sesuai rekomendasi keamanan pentest
        localStorage.removeItem('token');

        // Simpan state userAuth tanpa token di localStorage
        // eslint-disable-next-line no-unused-vars
        const { token: _t, ...safeState } = state;
        localStorage.setItem('userAuth', JSON.stringify(safeState));
    },
    unSet(state) {
        state.authenticated = false;
        state.token = null;
        state.user = {};
        state.userHasRoles = [];
        state.userHasPermissions = [];
        state.selectedModule = null;
        // Delete token dan user detail
        sessionStorage.removeItem('token');
        localStorage.removeItem('token');
        localStorage.removeItem('mapHardcodeMcr');
        localStorage.removeItem('userAuth');
        Cookies.remove('userAuth');
        clearDeviceId();
    },
    setSelectedModule(state, module) {
        state.selectedModule = module;
        // eslint-disable-next-line no-unused-vars
        const { token: _t, ...safeState } = state;
        localStorage.setItem('userAuth', JSON.stringify(safeState));
    },
    setMenuNav(state, obj) {
        state.menuNav = obj;
        // eslint-disable-next-line no-unused-vars
        const { token: _t, ...safeState } = state;
        localStorage.setItem('userAuth', JSON.stringify(safeState));
    },
    setSubMenuNav(state, obj) {
        state.subMenuNav = obj;
        // eslint-disable-next-line no-unused-vars
        const { token: _t, ...safeState } = state;
        localStorage.setItem('userAuth', JSON.stringify(safeState));
    },
    setUser(state, user) {
        state.user = user;
        // eslint-disable-next-line no-unused-vars
        const { token: _t, ...safeState } = state;
        localStorage.setItem('userAuth', JSON.stringify(safeState));
    },
    setUserRolesPermissions(state, { roles, permissions }) {
        state.userHasRoles = roles;
        state.userHasPermissions = permissions;
        // eslint-disable-next-line no-unused-vars
        const { token: _t, ...safeState } = state;
        localStorage.setItem('userAuth', JSON.stringify(safeState));
    },
    updStatMenuOrSubMenu(state, payload) {
        const { type, value } = payload;

        if (type === "menu") {
            if (state.menuNav[value]) state.menuNav[value].status = !state.menuNav[value].status;
            // eslint-disable-next-line no-unused-vars
            const { token: _t, ...safeState } = state;
            localStorage.setItem('userAuth', JSON.stringify(safeState));
        } else if (type === "submenu") {
            if (state.subMenuNav[value]) state.subMenuNav[value].status = !state.subMenuNav[value].status;
            // eslint-disable-next-line no-unused-vars
            const { token: _t, ...safeState } = state;
            localStorage.setItem('userAuth', JSON.stringify(safeState));
        }
    },
}

const actions = {
    login({ commit }, data) {
        commit('set', data); // Commit set dengan data login
    },
    logout({ commit }) {
        commit('unSet'); // Commit unSet untuk logout
    },
    setMenuNav({ commit }, data) {
        commit("setMenuNav", data);
    },
    setSubMenuNav({ commit }, data) {
        commit("setSubMenuNav", data);
    },
    setUser({ commit }, data) {
        commit('setUser', data);
    },
    setUserRolesPermissions({ commit }, data) {
        commit('setUserRolesPermissions', data);
    },
    updateStatMenuOrSubMenu({ commit }, { type, value }) {
        commit("updStatMenuOrSubMenu", { type, value });
    },
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
